<div class="search-container gap-3 d-flex justify-content-start align-items-center">
  <div class="search-box d-flex justify-content-center align-items-center">
    <img loading="lazy" src="media/icons/search.svg" alt="Search">
    <div class="input-content flex-grow-1">
      <input (keyup.enter)="onSearch()" (keyup)="value = inp.value" #inp class="form-control w-100 p-0"
        style="border: unset; box-shadow: unset; outline: unset;" type="text" id="search" name="search"
        [placeholder]="'FILTERS.SEARCH' | translate" required />
    </div>
    <img loading="lazy" src="media/icons/close.svg" class="" *ngIf="value" (click)="inp.value = ''; value = ''"
      alt="close">
  </div>
  <button (click)="onSearch()" [disabled]="!value" class="btn-primary without-min" type="button"
    translate="SEARCH"></button>
  <ng-content></ng-content>
</div>
<!-- @if (inp.touched && inp.invalid) {
<p class="text-danger mt-2">البحث مطلوب</p>
} -->

<!-- <div class="search-box d-flex align-items-center w-100">
          <img loading="lazy" src="media/icons/search.svg" alt="Search">
          <div class="input-content flex-grow-1">
            <input (keyup.enter)="onSearch(searchValue)" class="form-control p-0"
              style="border: unset; box-shadow: unset; outline: unset;" type="text" id="search" name="search"
              [placeholder]="'admin.access-control.bulk-access-browse.search.header' | translate"
              [(ngModel)]="searchValue" #search="ngModel" required />
            </div>
        </div> -->